<template>
  <div>
    <v-dialog
      v-model="display"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      width="600px"
      max-height="600px"
      scrollable
    >
      <v-card class="mx-auto secondary">
        <v-card-title class="px-2 py-0 ma-0 primary white--text">
          KONTAKT
        </v-card-title>
        <v-card-text style="height: 600px;">
          <v-form ref="contactForm" v-model="contactFormValid" lazy-validation>
            <v-row class="px-2 pt-2 ma-0" no-gutters>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 12">
                <v-select
                  v-model="problemArea"
                  :items="problemAreas"
                  item-text="name"
                  item-value="id"
                  label="Problemområde"
                  return-object
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row class="px-2 ma-0" no-gutters>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 12">
                <v-text-field
                  v-model="subject"
                  type="text"
                  label="Emne"
                  :rules="[rules.subject.required]"
                  clearable
                />
              </v-col>
            </v-row>
            <v-row class="px-2 pt-2 ma-0" no-gutters>
              <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 12">
                <v-textarea
                  v-model="message"
                  label="Besked"
                  auto-grow
                  rows="10"
                  :rules="[rules.message.required]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn class="text-left" @click="cancel()">
            FORTRYD
          </v-btn>
          <v-spacer />
          <v-btn class="text-right" @click="submit()">
            SEND
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="displayResult"
      :color="
        resultError
          ? this.$vuetify.theme.themes.light.error
          : this.$vuetify.theme.themes.light.success
      "
    >
      {{ resultText }}
    </v-snackbar>
  </div>
</template>
<script>
export default {
  name: "ContactDialog",
  data() {
    return {
      contactFormValid: false,
      problemArea: "",
      subject: "",
      message: "",
      rules: {
        subject: {
          required: v => !!v || "Angiv emne"
        },
        message: {
          required: v => !!v || "Angiv besked"
        }
      },
      displayResult: false,
      resultError: false,
      resultText: ""
    };
  },
  computed: {
    display() {
      return this.$store.state.authentication.displayContactDialog;
    },
    problemAreas() {
      return [
        { id: 1, name: "Booking" },
        { id: 2, name: "Pris" },
        { id: 3, name: "Klage" }
      ];
      // load from user settings
      // return JSON.parse(this.$store.state.user.activeUser.settings.problem_areas);
    }
  },
  methods: {
    loadProblemAreas() {},
    cancel() {
      this.disposeDialog();
    },
    async submit() {
      this.$refs.contactForm.validate();
      if (this.contactFormValid && this.subject && this.message) {
        //     const user = this.$store.state.user.userForUpdate;
        //     const password = this.$store.state.user.password;
        //     await this.$store.dispatch('user/updateUser', { user, password })
        //         .then(response => {
        //                 this.displayResult = true,
        //                 this.resultText = response;
        //                 this.resultError = false;
        //             },
        //             error => {
        //                 console.error(error);
        //                 this.displayResult = true,
        //                 this.resultText = error;
        //                 this.resultError = true;
        //             });
        this.disposeDialog();
      }
    },
    disposeDialog() {
      this.$refs.contactForm.reset();
      this.$store.commit("authentication/setDisplayContactDialog", false);
      this.goBack();
    },
    goBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push("/booking");
    }
  }
};
</script>
